<template>
  <div>
    <ApexChart
      height="319"
      type="line"
      :options="options"
      :series="series"
    />
  </div>
</template>

<script>
import ApexChart from "vue-apexcharts";

export default {
  components: {
    ApexChart,
  },
  props: {
    metrics: Array,
    dataFrom: String,
    graphOptions: Object,
  },
  data() {
    return {};
  },
  computed: {
    options() {
      let options = {...this.graphOptions};
      options.xaxis.categories = this.categories;
      options.yaxis.labels.formatter = function (value) {
        if (value === null) {
          return this.$t("heading.hosting.usage.graphs.noData");
        }
        if (value === 0) {
          return "0 Bps";
        }
        const sizes = ["Bps", "KBps", "MBps", "GBps", "TBps"];
        const i = Math.floor(Math.log(value) / Math.log(1024));
        const output = value / Math.pow(1024, i);
        return `${output.toFixed(2)} ${sizes[i]}`;
      };
      options.legend = {
        show: false
      };
      return options;
    },
    series() {
      return [
        {
          name: this.$t("heading.hosting.usage.graphs.in"),
          data: this.dataIn,
        },
        {
          name: this.$t("heading.hosting.usage.graphs.out"),
          data: this.dataOut,
        },
      ];
    },
    dataIn() {
      if (this.metrics === null) {
        return [];
      }
      let data = [];
      for (let m of this.metrics) {
        data.push({
          x: m.period,
          y: Object.hasOwn(m, "net_in_bps") ? m.net_in_bps : null,
        });
      }
      return data;
    },
    dataOut() {
      if (this.metrics === null) {
        return [];
      }
      let data = [];
      for (let m of this.metrics) {
        data.push({
          x: m.period,
          y: Object.hasOwn(m, "net_out_bps") ? m.net_out_bps : null,
        });
      }
      return data;
    },
    categories() {
      let categories = [];
      for (let d of this.dataIn) {
        categories.push(d.x);
      }
      return categories;
    },
  },
};
</script>